
import styles from "./SurveyForm.module.scss";
import { Button, Layout } from "components";
import { useState } from 'react';
import single_selection_icon from 'assets/icons/testicons/single_selection.png'
import add_icon from 'assets/icons/testicons/add.png'
import list_icon from 'assets/icons/testicons/list.png'
import numeric_icon from 'assets/icons/testicons/numeric.png'
import textbox_icon from 'assets/icons/testicons/text-box.png'
import equalizer_icon from 'assets/icons/testicons/equalizer.png'
import freedom_of_speech_icon from 'assets/icons/testicons/freedom-of-speech.png'
import planning_icon from 'assets/icons/testicons/planning.png'
import accordance_icon from 'assets/icons/testicons/list_acc.png'
import gap_icon from 'assets/icons/testicons/gap.png'
import textfield_icon from 'assets/icons/testicons/text-field.png'
import dictation_icon from 'assets/icons/testicons/dictation.png'
import slider_icon from 'assets/icons/testicons/slider.png'
import exception_icon from 'assets/icons/testicons/exception.png'
import document_icon from 'assets/icons/testicons/document.png'
import info_icon from 'assets/icons/testicons/info.png'
import alphabet_icon from 'assets/icons/testicons/alphabet.png'
import hierarchicalstructure_icon from 'assets/icons/testicons/hierarchical-structure.png'
import index_icon from 'assets/icons/testicons/index.png'
import icon_delete from 'assets/icons/delete.png'
import Notification from "utils/Notifications";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { PostPartSurveySurvey } from "service/SurveyService";
const buttonData = [
    { id: 'singleSelection', icon: single_selection_icon, label: 'Одиночный выбор' },
    { id: 'multipleSelection', icon: list_icon, label: 'Множественный выбор' },
    { id: 'numericInput', icon: numeric_icon, label: 'Ввод числа' },
    { id: 'textInput', icon: textbox_icon, label: 'Ввод текста' },
    { id: 'freeTextDefendant', icon: freedom_of_speech_icon, label: 'Ответ в свободной форме' },
    { id: 'fileUpload', icon: document_icon, label: 'Загрузка файла' },
    { id: 'infoText', icon: info_icon, label: 'Информационный текст' },
];


const SurveyForm = ({ id, setRender }) => {
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [selected, setSelected] = useState(null);


    const handleSelection = (id) => {
        setRows([
            { id: 1, textValue: "", score: 0, min: "", max: "", isChecked: false, file: null },
        ]);
        setNumberField('');
        setSelectField('100');
        setPointsWrong('');
        setPointsCorrect('');
        // setFile(null);
        // setEditorState(EditorState.createEmpty());
        setSelected(id);
        if (id === 'sequenceOrdering') {
            setCheckpoints(false)
        }

    };


    const [text, setText] = useState('');

    const handleChange = (event) => {
        setText(event.target.value);
    };





    const [rows, setRows] = useState([
        { id: 1, editorState: EditorState.createEmpty(), score: 0, rdefendant: 0, file: null, textValue: "", min: "", max: "" },
    ]);


    const addRow = () => {
        const newRow = {
            id: rows.length + 1,
            editorState: EditorState.createEmpty(),
            score: 0,
        };
        setRows([...rows, newRow]);
    };

    const removeRow = (id) => {
        const updatedRows = rows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
                ...row,
                id: index + 1, // Обновляем ID для правильной нумерации
            }));
        setRows(updatedRows);
    };
    const moveRow = (index, direction) => {
        const newRows = [...rows];

        // Перемещение строки вверх
        if (direction === "up" && index > 0) {
            const temp = newRows[index];
            newRows[index] = newRows[index - 1];
            newRows[index - 1] = temp;
        }
        // Перемещение строки вниз
        else if (direction === "down" && index < rows.length - 1) {
            const temp = newRows[index];
            newRows[index] = newRows[index + 1];
            newRows[index + 1] = temp;
        }

        // Обновляем ID строк
        const updatedRows = newRows.map((row, i) => ({
            ...row,
            id: i + 1, // Пересчитываем ID на основе позиции в массиве
        }));

        setRows(updatedRows);
    };
    const [selectField, setSelectField] = useState('100');

    const [pointswrong, setPointsWrong] = useState('');
    const [pointscorrect, setPointsCorrect] = useState('');
    const [numberField, setNumberField] = useState('');
    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [editorStateComment, setEditorStateCom] = useState(EditorState.createEmpty());

    const onEditorStateChangeComment = (newState) => {
        setEditorStateCom(newState);
    };

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
    };

    const handleEditorChange = (index, newEditorState) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, editorState: newEditorState } : row
        );
        setRows(updatedRows);
    };

    const handleScoreChange = (index, newScore) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, score: newScore } : row
        );
        setRows(updatedRows);
    };
    const handleRightAnChange = (index, newRdefendant) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, rdefendant: newRdefendant } : row
        );
        setRows(updatedRows);
    };

    const [checkpoints, setCheckpoints] = useState(true);

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;

        if (e.target.name === "first") {
            setCheckpoints(isChecked); // При клике на "По ответам" обновляется checkpoints
        } else if (e.target.name === "second") {
            setCheckpoints(!isChecked); // При клике на "Весь вопрос" обновляется checkpoints (обратное состояние)
        }
    };
    const handleNumericChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            numericValue: value,
        };
        setRows(updatedRows);
    };

    // Function for text input changes
    const handleTextChange = (index, value, field) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            [field]: value,
        };
        setRows(updatedRows);
    };
    // Function for optional numeric input changes
    const handleOptionalNumericChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            optionalNumericValue: value,
        };
        setRows(updatedRows);
    };

    const handleCheckboxChange_row = (index, isChecked) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, isChecked } : row
        );
        setRows(updatedRows);
    };



    const handleFileChange = (index, file) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, file: file } : row
        );
        setRows(updatedRows);
    };

    const handleSelectChange = (index, newValue) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, selectedNumber: newValue } : row
        );
        setRows(updatedRows);
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        // Проверяем обязательные поля (добавьте свои проверки)
        if (!editorState || !editorState.getCurrentContent().hasText()) {
            setNotify({
                isOpen: true,
                message: "Пожалуйста, заполните текст вопроса.",
                type: "error",
            });
            return;  // Останавливаем выполнение, если текст не введен
        }

        const formData = new FormData();

        // Общие данные

        formData.append('checkpoints', checkpoints)
        formData.append('max_points_for_the_correct_defendant', numberField);
        formData.append('type_defendant', selected);
        formData.append('points_for_the_wrong_defendant', pointswrong);
        formData.append('points_for_the_correct_defendant', pointscorrect);
        formData.append('max_len', selectField);

        if (file) {
            formData.append('image', file); // Общий файл
        }
        // formData.append('body', JSON.stringify(convertEditorStateToRaw(editorState))); // Конвертация editorState
        formData.append('body', convertEditorStateToRaw(editorState));
        formData.append('comment', convertEditorStateToRaw(editorStateComment));

        // Данные строк (rows)
        const rowsData = rows.map(row => ({
            defendant_number: row.id,
            points: row.score || 0,
            rdefendant: row.rdefendant || 0,
            min_len: row.min || "",
            max_len: row.max || "",
            right_defendant: row.isChecked || false,
            sequences_selectedNumber: row.selectedNumber || 1,
            type_input_txt: row.textValue || "",
            type_input_int: row.numericValue || null,
            error_rate: row.optionalNumericValue || null,
            title: row.editorState ? convertEditorStateToRaw(row.editorState) : null,
        }));

        // Добавляем сериализованные строки в formData
        formData.append('parts', JSON.stringify(rowsData));

        // Добавляем файлы для строк отдельно, если есть
        rows.forEach((row, index) => {
            if (row.file) {
                formData.append(`imageparts[${index}]`, row.file);
            }
        });

        // Отправка данных
        try {
            const response = await PostPartSurveySurvey(id, formData); // Вызов вашей API функции
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });

            // Очистка после успешной отправки
            setRows([
                { id: 1, textValue: "", score: 0, min: "", max: "", isChecked: false, file: null },
            ]);
            setNumberField('');
            setSelectField('100');
            setFile(null);
            setPointsWrong('');
            setPointsCorrect('');
            setEditorState(EditorState.createEmpty());
            setRender(true)
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };

    // Вспомогательная функция для конвертации editorState в raw формат
    const convertEditorStateToRaw = (editorState) => {
        return editorState ? JSON.stringify(convertToRaw(editorState.getCurrentContent())) : null;
    };

    return (
        <div className={styles.test_card_body_aud}>
            <div className={styles.test_card_body}>
                <div className={styles.test_card_right_2}>
                    <div className={styles.buttons_set}>
                        <select
                            className={styles.select_test}
                            onChange={(e) => handleSelection(e.target.value)} // Получение выбранного значения
                        >
                            {buttonData.map((button) => (
                                <option key={button.id} value={button.id}>
                                    {button.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {selected !== null ? (<>
                    <div className={styles.test_card_left}>

                        <div className={styles.div_selection}>
                            {selected === 'singleSelection' && <h2>Одиночный выбор</h2>}
                            {selected === 'multipleSelection' && <h2>Множественный выбор</h2>}
                            {selected === 'numericInput' && <h2>Ввод числа</h2>}
                            {selected === 'textInput' && <h2>Ввод текста</h2>}
                            {selected === 'freeTextDefendant' && <h2>Ответ в свободной форме</h2>}
                            {selected === 'fileUpload' && <h2>Загрузка файла</h2>}
                            {selected === 'infoText' && <h2>Информационный текст</h2>}
                            {selected === 'wordsFromLetters' && <h2>Слова из букв</h2>}
                            {selected === 'phrasesFromWords' && <h2>Фразы из слов</h2>}
                            {selected === 'textSearch' && <h2>Поиск в тексте</h2>}
                            <button
                                onClick={handleSubmit}
                                className={styles.btn_action_save}
                            >
                                Сохранить элемент
                            </button>
                        </div>
                        <div className={styles.test_card_left_selection}>
                            <div>
                                <label>Если есть изображение Анкетирования,  </label>

                                <input
                                    type="file"
                                    id="file-upload"
                                    className={styles.file_upload_input}
                                    onChange={handleFileChange_test}  // Исправлено: вызываем функцию
                                />
                                <label htmlFor="file-upload" className={styles.file_upload_label}>
                                    {file ? file.name : 'Загрузите изображение'}
                                </label>
                            </div>

                            <div>
                                <label>Текст вопроса</label>
                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    toolbar={{
                                        options: ["inline", "blockType", "list", "textAlign", "link", "history"],
                                        inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                    }}
                                    wrapperStyle={{ border: "1px solid #ccc", marginBottom: "20px" }}
                                    editorStyle={{ minHeight: "200px", padding: "10px" }}
                                />




                            </div>
                       

                            <div>

                                <div>
                                 
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                {(selected !== 'freeTextDefendant' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                                    <th className={styles.test_row_title}>№</th>}
                                                {(selected === 'singleSelection' || selected === 'multipleSelection') &&
                                                    <th className={styles.test_row_title}>Картинка</th>}
                                                {(selected === 'singleSelection' || selected === 'multipleSelection') &&
                                                    <th className={styles.test_row_title}>
                                                        Текст вариантов ответов
                                                    </th>}

                                                {(selected === 'slider') &&
                                                    <th className={styles.test_row_title}>
                                                        Название слайдера
                                                    </th>}
                                                {(selected === 'numericInput' || selected === 'textInput') &&
                                                    <th className={styles.test_row_title}>
                                                        Ввод
                                                    </th>}

                                              
                                               
                                              
                                                {((selected === 'multipleSelection')) &&

                                                    <th className={styles.test_row_title}>
                                                        Выбор
                                                    </th>
                                                }



                                                {(selected !== 'freeTextDefendant' && selected !== 'fileUpload' && selected !== 'infoText') &&

                                                    <th className={styles.test_row_title}>
                                                        Действия
                                                    </th>
                                                }
                                            </tr>
                                        </thead>
                                        {(selected === 'freeTextDefendant') &&

                                            <tbody>

                                                <td className={styles.test_row}>
                                                    <input
                                                        type="number"
                                                        className={styles.point_check_num_text}
                                                        value={numberField}  // привязываем к состоянию
                                                        onChange={(e) => setNumberField(e.target.value)}  // обновляем только numberField
                                                    />
                                                </td>
                                                <td className={styles.test_row}>
                                                    <select
                                                        className={styles.point_check_num_text}
                                                        value={selectField}  // привязываем к состоянию
                                                        onChange={(e) => setSelectField(e.target.value)}  // обновляем только selectField
                                                    >
                                                        <option value="100">100</option>
                                                        <option value="250">250</option>
                                                        <option value="500">500</option>
                                                        <option value="750">750</option>
                                                        <option value="1000">1000</option>
                                                        <option value="1500">1500</option>
                                                        <option value="2000">2000</option>
                                                        <option value="2500">2500</option>
                                                        <option value="5000">5000</option>
                                                        <option value="10000">10000</option>
                                                        <option value="15000">15000</option>
                                                    </select>
                                                </td>

                                            </tbody>
                                        }
                                      
                                        {(selected !== 'freeTextDefendant' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                            <tbody>
                                                {rows.map((row, index) => (
                                                    <tr key={row.id}>
                                                        {selected !== 'freeTextDefendant' &&
                                                            <td className={styles.test_row}>
                                                                {row.id}
                                                            </td>
                                                        }
                                                        {(selected === 'singleSelection' || selected === 'multipleSelection') &&
                                                            <td className={styles.test_row}>

                                                                {/* Скрываем стандартный input и используем кастомный label */}
                                                                <input
                                                                    type="file"
                                                                    id={`file-upload-${row.id}`}  // Уникальный id для каждого input
                                                                    className={styles.file_upload_input}
                                                                    onChange={(e) => handleFileChange(index, e.target.files[0])}
                                                                />
                                                                <label htmlFor={`file-upload-${row.id}`} className={styles.file_upload_label}>
                                                                    {row.file ? row.file.name : 'Загрузить изображение'}
                                                                </label>


                                                            </td>
                                                        }
                                                        {(selected === 'singleSelection' || selected === 'multipleSelection') &&
                                                            <td className={styles.test_row}>
                                                                <Editor
                                                                    editorState={row.editorState}
                                                                    onEditorStateChange={(newEditorState) =>
                                                                        handleEditorChange(index, newEditorState)
                                                                    }
                                                                    toolbar={{
                                                                        options: [
                                                                            "inline",
                                                                            "blockType",
                                                                            "list",
                                                                            "textAlign",
                                                                            "link",
                                                                            "history",
                                                                        ],
                                                                        inline: {
                                                                            options: ["bold", "italic", "underline", "strikethrough"],
                                                                        },

                                                                    }}
                                                                    wrapperStyle={{
                                                                        border: "1px solid #ccc",
                                                                    }}
                                                                    editorStyle={{
                                                                        minHeight: "50px",
                                                                        padding: "5px",
                                                                    }}
                                                                />
                                                            </td>
                                                        }

                                                        {(selected === 'numericInput') &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="number"
                                                                    className={styles.point_check_num_text}
                                                                    value={row.numericValue || ''} // Add value if needed
                                                                    onChange={(e) => handleNumericChange(index, e.target.value)}
                                                                />
                                                            </td>
                                                        }

                                                        {(selected === 'textInput') &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="text"
                                                                    className={styles.point_check_num_text}
                                                                    value={row.textValue || ''} // Add value if needed
                                                                    onChange={(e) => handleTextChange(index, e.target.value, "textValue")}
                                                                />
                                                            </td>
                                                        }
                                                        {(selected === 'slider') &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="text"
                                                                    className={styles.point_check_num_text}
                                                                    value={row.textValue || ""}
                                                                    onChange={(e) => handleTextChange(index, e.target.value, "textValue")}
                                                                />
                                                                <tr className={styles.point_check_under_tr}>
                                                                    <td>
                                                                        <label>Минимальное значение:</label>
                                                                        <input
                                                                            type="number"
                                                                            className={styles.point_check_num_text}
                                                                            value={row.min || ""}
                                                                            onChange={(e) => handleTextChange(index, e.target.value, "min")}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <label>Максимальное значение:</label>
                                                                        <input
                                                                            type="number"
                                                                            className={styles.point_check_num_text}
                                                                            value={row.max || ""}
                                                                            onChange={(e) => handleTextChange(index, e.target.value, "max")}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </td>
                                                        }
                                                       




                                                        {(selected === 'multipleSelection' ) &&
                                                            <td className={styles.test_row}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={row.isChecked}  // предполагаем, что в row есть поле isChecked
                                                                    className={styles.point_check}
                                                                    onChange={(e) => handleCheckboxChange_row(index, e.target.checked)}
                                                                />
                                                            </td>
                                                        }

                                                    
                                                        {selected !== 'freeTextDefendant' && <>
                                                            <td className={styles.test_row}>
                                                                {index > 0 && (
                                                                    <button
                                                                        onClick={() => moveRow(index, "up")}
                                                                        className={styles.btn_action_move}
                                                                    >
                                                                        ↑
                                                                    </button>
                                                                )}

                                                                <button
                                                                    onClick={() => removeRow(row.id)}
                                                                    className={styles.btn_action_delete}
                                                                >
                                                                    <img
                                                                        src={icon_delete}
                                                                        className={styles.img}
                                                                        alt="Удалить"
                                                                    />
                                                                </button>

                                                                {index < rows.length - 1 && (
                                                                    <button
                                                                        onClick={() => moveRow(index, "down")}
                                                                        className={styles.btn_action_move}
                                                                    >
                                                                        ↓
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </>}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        }
                                    </table>
                                    {(selected !== 'freeTextDefendant' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                        <button
                                            onClick={addRow}
                                            className={styles.btn_action_add}
                                        >
                                            Добавить строку
                                        </button>
                                    }

                                    <div style={{ marginTop: '40px' }}>
                                        <label>Примечание к вопросу</label>
                                        <Editor
                                            editorState={editorStateComment}
                                            onEditorStateChange={onEditorStateChangeComment}
                                            toolbar={{
                                                options: ["inline", "blockType", "list", "textAlign", "link", "history"],
                                                inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                            }}
                                            wrapperStyle={{ border: "1px solid #ccc", marginBottom: "20px" }}
                                            editorStyle={{ minHeight: "100px", padding: "10px" }}
                                        />




                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </>) : (
                    <div className={styles.test_card_left_none}>
                        <h4 >
                            В вашем анкетировании еще нет ни одного вопроса.<br></br>
                            Чтобы добавить новый вопрос выберите необходимые элементы в правой навигации экрана для показа панели со списком вопросов.
                        </h4>
                    </div>
                )}
                <div className={styles.test_card_right}>
                    <div className={styles.buttons_set}>
                        {buttonData.map((button) => (
                            <div
                                key={button.id}
                                className={styles.button_form_creator}
                                onClick={() => handleSelection(button.id)}
                            >
                                <div className={styles.button_form_creator_header}>
                                    <img
                                        src={button.icon}
                                        alt={`Иконка ${button.label}`}
                                        className={styles.img}
                                    />
                                    <span>{button.label}</span>
                                </div>
                                <img
                                    src={add_icon}
                                    alt="Иконка добавления"
                                    className={styles.img}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <Notification notify={notify} setNotify={setNotify} />
            </div>
        </div>
    );
};

export default SurveyForm;
